define('models/transaction',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        defaults: function () {
            return {
                basket: {},
                description: '',
                created: '',
                payment_service: '',
                installments: 1,
                subject_details: {},
                is_recurring: false
            };
        }
    });
});
